import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

// The allenatore's profile. A dirigente who also coaches reaches it from the menu: `/` sends
// them to `/me/official` instead, the club-wide incarico being the wider one.
export const myCoachRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/me/coach',
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['coach'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/my-coach.tsx')),
})
